"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setPointRadius = setPointRadius;
var _types = require("../types");
var _ramda = require("ramda");
var _datasetUtils = require("./datasetUtils");
var _constants = require("./constants");
/** Настраивает (мутирует) конфиг для поля radius пути cfg.options.elements.point */
function setPointRadius(cfg, props) {
  const lens = (0, _ramda.lensPath)(['elements', 'point', 'radius']);
  if (props.eachPointAnnotation) {
    cfg.options = (0, _ramda.set)(lens, pointRadiusEach(props.isDesktop), cfg.options);
  } else {
    cfg.options = (0, _ramda.set)(lens, pointRadius, cfg.options);
  }
}

/**
 * Конфигурация radius для случая, когда выбрана опция eachPointAnnotation.
 * В этом случае, в десктопе все точки графика делаются увеличенного размера,
 * в мобайле, если нет ховера, крайние точки делаются увеличенного размера.
 * Если есть ховер, увеличивается только точка под ховером
 * */
function pointRadiusEach(isDesktop) {
  return function (ctx) {
    if (isDesktop) {
      return _constants.POINT_ENDS_RADIUS;
    }
    if (ctx.chart.isHover) {
      return 0;
    } else {
      return getEndPointsRadius(ctx);
    }
  };
}

/**
 * Конфигурация radius для случая, когда не выбрана опция eachPointAnnotation
 * В этом случае, крайние точки линий делаются увеличенными, а остальные увеличиваются по ховеру\тапу
 * */
function pointRadius(ctx) {
  const dataset = ctx.chart.data.datasets[ctx.datasetIndex];
  if (dataset.id === _types.EChartDatasetId.EstimatedPrice) {
    return getEstimationLinePointsRadius(ctx);
  }
  return getEndPointsRadius(ctx);
}

/**
 * Функция работает с линией estimation, которая может делиться на 2 сегмента, 1й полупрозрачный.
 * Задает основному сегменту линии estimation особый радиус крайних точек
 *  */
function getEstimationLinePointsRadius(ctx) {
  const dataIndex = ctx.dataIndex;
  const dataset = ctx.chart.data.datasets[ctx.datasetIndex];
  const datasetLength = dataset.data.length;
  const {
    estimationPricePoint
  } = (0, _datasetUtils.getLinesBeginPoints)(ctx);
  const isPointTheBeginOfEstimationLine = estimationPricePoint && ctx.parsed.x === estimationPricePoint.date;
  if (isPointTheBeginOfEstimationLine || dataIndex === datasetLength - 1) {
    return _constants.POINT_ENDS_RADIUS;
  }
  return _constants.POINT_RADIUS;
}

/** Функция выставляет крайним точкам линии особый радиус */
function getEndPointsRadius(ctx) {
  const dataIndex = ctx.dataIndex;
  const dataset = ctx.chart.data.datasets[ctx.datasetIndex];
  const datasetLength = dataset.data.length;
  if ([0, datasetLength - 1].includes(dataIndex)) {
    return _constants.POINT_ENDS_RADIUS;
  }
  return _constants.POINT_RADIUS;
}